<template>
    <v-flex xs12 md10 offset-md1>
        <v-toolbar color="blue darken-2" dark>
            <v-toolbar-title>Delete Device</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
            <v-card-title>
                <v-text-field
                        v-model="deleteDeviceConfirmation"
                        label="Enter device serial number to confirm deletion"
                        single-line
                        hide-details
                        mask="###############"
                ></v-text-field>
                <v-btn color="default" @click="deleteDeviceCheck">Delete This Device</v-btn>
            </v-card-title>
        </v-card>

        <v-dialog v-model="deleteDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Delete This Device?</v-card-title>
                <v-card-text>Please confirm that you want to delete this device. Note that this action cannot be
                    undone.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click.native="startDeleteDevice">Yes, delete</v-btn>
                    <v-btn color="green darken-1" flat @click.native="deleteDialog = false">No, cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-flex>
</template>

<script>
    const fb = require('../firebase')

    export default {
        name: 'DeviceDelete',
        props: ['id', 'group'],
        data() {
            return {
                deleteDeviceConfirmation: '',
                deleteDialog: false,
                hideProgress: true
            }
        },
        methods: {
            removeItemFromArray: function (val, arr) {
                let newItems = []
                arr.forEach(function (item) {
                    if (val !== item) {
                        newItems.push(item)
                    }
                })
                return newItems
            },
            deleteDeviceCheck: function () {
                if (this.deleteDeviceConfirmation === this.id) {
                    this.deleteDialog = true
                } else {
                    this.$store.commit('showSnack', 'Please enter the correct device serial number.')
                }
            },
            startDeleteDevice: async function () {
                this.deleteDeviceConfirmation = ''
                this.deleteDialog = false

                await fb.devicesCollection
                    .where('serial', '==', this.id)
                    .get()
                    .then((devices) => {
                        if (!devices.empty) {
                            devices.forEach((device) => {
                                fb.devicesCollection.doc(device.id).delete()
                            })
                        }
                    })

                // remove from old group
                await fb.groupsCollection
                    .doc(this.group)
                    .get()
                    .then((doc) => {
                        let newArray = this.removeItemFromArray(this.id, doc.data().devices)
                        fb.groupsCollection
                            .doc(this.group)
                            .set({devices: newArray}, {merge: true})
                    })

                await fb.settingsCollection
                    .doc('castles_' + this.id + '@kineticsmart.com')
                    .delete()

                await fb.tokensCollection
                    .doc('castles_' + this.id + '@kineticsmart.com')
                    .delete()

                this.$store.commit('showSnack', 'Device deleted')
                this.$router.push({path: '/group/' + this.group})
            }
        }
    }
</script>

<style scoped>

</style>
